import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import {
  // Link,
  LinkIcon
} from '../'
import Styles from './FinanceCompanyScore.css'


@CSSModules(Styles, {allowMultiple: true})
export default class FinanceCompanyScore extends Component {
  static propTypes = {
    score: PropTypes.string.isRequired,
    large: PropTypes.bool
  }
  constructor(props){
    super(props)
  }

  render() {
    let _score = format.number(this.props.score, false, false, 1)
    const styl = parseInt(_score, 10)
    if (parseFloat(_score) === 0) {
      _score = '<0.1'
    } else if (_score.slice(-1)==='0') {
      _score = format.number(this.props.score, false, false, 0)
    }

    // fc = finance-company
    const wrapStyle = this.props.large ?
      'fc-wrap-large' :
      'fc-wrap'

    //
    return (
      <span styleName={wrapStyle}>
        <span styleName='fc'>
          {_score}
          <span styleName={'fc-circle-icon-' + styl}>
            <LinkIcon faclass='fa-circle' />
          </span>
        </span>
      </span>
    )
  }
}

